import { Box } from '@mui/material'
import type { TitleProps } from '@refinedev/core'
import { ThemedLayoutV2, ThemedSiderV2 } from '@refinedev/mui'
import React from 'react'

interface CustomLayoutProps {
  children: React.ReactNode
  Title?: React.FC<TitleProps>
}

interface SiderRenderProps {
  items: React.ReactNode
  logout: React.ReactNode
  collapsed: boolean
}

export const CustomLayout: React.FC<CustomLayoutProps> = ({ children, Title }) => {
  // Custom Sider component with logout button positioned at bottom
  const CustomSider = (props: React.ComponentProps<typeof ThemedSiderV2>) => {
    return (
      <ThemedSiderV2
        {...props}
        render={({ items, logout }: SiderRenderProps) => {
          return (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: 'calc(100vh - 80px)',
                justifyContent: 'space-between',
              }}
            >
              {/* Navigation items at the top */}
              <Box sx={{ flex: 1, overflow: 'auto' }}>{items}</Box>

              {/* Logout button at the bottom */}
              <Box sx={{ borderTop: 1, borderColor: 'divider' }}>{logout}</Box>
            </Box>
          )
        }}
      />
    )
  }

  return (
    <ThemedLayoutV2 Title={Title} Sider={CustomSider}>
      {children}
    </ThemedLayoutV2>
  )
}
